import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrButton = _resolveComponent("NrButton")!

  return (_openBlock(), _createBlock(_component_NrButton, _mergeProps({
    variant: _ctx.variant,
    class: _ctx.classnames,
    "aria-label": `${_ctx.day.toDateString()}`,
    tabindex: _ctx.focus ? 0 : -1,
    disabled: _ctx.disabled
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.humanizeDay), 1)
    ]),
    _: 1
  }, 16, ["variant", "class", "aria-label", "tabindex", "disabled"]))
}